/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from "react";
import { Container, Row, Col } from "reactstrap";

// Redux
import { useSelector } from "react-redux";

//The two main components of the second container area: AgentTable and his header, only.
import AgentsTable from "./components/AgentsTable/index";

import "./ManagerPanelSecondContainer.scss";

const index = ({ onExpand, setLastUpdateCSAT }) => {
  const { mainTheme } = useSelector((state) => state.Layout);

  const [isBacksoonClicked, setBacksoonClicked] = useState(false);
  const [isOnlineClicked, setOnlineClicked] = useState(false);
  const [isOfflineClicked, setOfflineClicked] = useState(false);

  function handleBacksoonClick() {
    setBacksoonClicked(!isBacksoonClicked);
  }

  function handleOnlineClick() {
    setOnlineClicked(!isOnlineClicked);
  }

  function handleOfflineClick() {
    setOfflineClicked(!isOfflineClicked);
  }

  return (
    <Container
      className={`container-panel ${mainTheme} w-100 px-1 m-2`}
      fluid={true}
    >
      <Row className="w-100 mx-0">
        <Col xs="12" sm="12" md="12" lg="12" xg="12">
          <AgentsTable
            onlineFilterClicked={() => handleOnlineClick()}
            backsoonFilterClicked={() => handleBacksoonClick()}
            offlineFilterClicked={() => handleOfflineClick()}
            onExpand={onExpand}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default index;
